import MyPostsFrameDesktop from './my-posts-frame-desktop';
import MyPostsFrameMobile from './my-posts-frame-mobile';
import forDevice from '../../../common/hoc/for-device';

export default forDevice(MyPostsFrameMobile, MyPostsFrameDesktop);
